import useActiveAnnouncementCampaign from 'hooks/useActiveAnnouncementCampaign'
import { useActiveSenderIds } from 'hooks/useActiveSenderId'
import React from 'react'
import { useSelector } from 'react-redux'
import { CTAType } from 'types/message'

import SenderInfo from '../SenderInfo'
import DefaultCTA from './DefaultCTA'

import './style.css'

interface WelcomeMessageMessageProps {
  previewRef: React.Dispatch<any>
}

const WelcomeMessage = ({ previewRef }: WelcomeMessageMessageProps) => {
  const { chatOpen } = useSelector(state => state.view)
  const { body, ctaCopy, ctaType, ctaUrl } = useActiveAnnouncementCampaign()
  const senderIds = useActiveSenderIds()

  if (!chatOpen) {
    return null
  }

  return (
    <div className="drift-widget-greeting">
      <SenderInfo senderIds={senderIds} />
      <div
        className="drift-widget-welcome-message-content"
        dangerouslySetInnerHTML={{ __html: body }}
        ref={previewRef}
      />
      {ctaCopy && ctaType !== CTAType.CHAT_RESPONSE &&
        <DefaultCTA copy={ctaCopy} type={ctaType} url={ctaUrl} />
      }
    </div>
  )
}

export default WelcomeMessage
